import styled from 'styled-components';
import colors from '../../../helpers/colors';
import spacing from '../../../helpers/spacing';

const shapeBorderRadius = '8px';
export const ReadTimeShape = styled.div`
  background-color: ${colors.neutral07};
  padding: ${spacing(1)} ${spacing(2)};
  position: relative;

  border-radius: ${shapeBorderRadius} ${shapeBorderRadius} 0 0;

  ::before,
  ::after {
    content: '';
    position: absolute;
    width: calc(2 * ${shapeBorderRadius});
    bottom: 0;
    height: ${shapeBorderRadius};
  }

  ::before {
    left: calc(-2 * ${shapeBorderRadius});
    border-radius: 0 0 ${shapeBorderRadius} 0;
    box-shadow: ${shapeBorderRadius} 0 0 0 ${colors.neutral07};
  }

  ::after {
    right: calc(-2 * ${shapeBorderRadius});
    border-radius: 0 0 0 ${shapeBorderRadius};
    /* IE doesn't like calc in box-shadow so we directly add a minus sign. See 
       "known issues" in https://caniuse.com/#feat=calc */
    box-shadow: -${shapeBorderRadius} 0 0 0 ${colors.neutral07};
  }
`;
